module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/readable-stream/writable-browser.js
// module id = 344
// module chunks = 0